import { render } from "./SignupForm.vue?vue&type=template&id=57f1230f&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=57f1230f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57f1230f"

export default script